module.exports = __webpack_public_path__ + "assets/img/video-btn-f8b025a8.png";